<template>


      <TableToolbar :buttons="['filter', 'info']"
                  :id="'signalsTabs'"
                  :info="dictionary.signals.note"
                  :isFilterShown="showFilter"
                  @cancelFilter="showFilter = false;"
                  @toggleFilter="showFilter = !showFilter">
      <template #toolbarFilter="{filterButtonRef}">
        <keep-alive>
        <ListFilter v-if="showFilter" @cancel="showFilter = false" ref="filterPanel" @applyFilter="applyFilter"
                    :filterButtonRef="filterButtonRef" :defaultSelect="filters"/>
        </keep-alive>
      </template>


      <template #main>
        <div>
          <div id="filterPanel">
            <div id="flexBlock">
             

            </div>

            <tabs id="filterTabs" @tabClick="setTab" transparent="true" no-border="true"
                  :round="true"
                  :tabs="[{
                    label: dictionary.signals.ath,
                    value: 'ath'
                  }, {
                    label: dictionary.signals.low52,
                    value: '52weeksLow'
                  }, {
                    label: dictionary.signals.high52,
                    value: '52weeksHigh'
                  }]"
                  :active-tab="activeTab"/>

            <div class="selectedIndex hideMobile">
              {{ selectedIndexLabel }}
            </div>
          </div>
          <div class="selectedIndex showMobile">
            {{ selectedIndexLabel }}
          </div>
        </div>

      </template>
    </TableToolbar>

  <low-high52-signals key="52weeksHigh" v-if="activeTab === '52weeksHigh'" ref="52weeks" signals="high52" :filters="filters"/>
  <low52-signals key="52weeksLow" v-if="activeTab === '52weeksLow'" ref="52weeks" signals="low52" :filters="filters"/>
  <ath-signals key="ath" v-if="activeTab === 'ath'" ref="ath" signals="ath" :filters="filters"/>
</template>

<script>
import LowHigh52Signals from "./signals/High52Signal";
import AthSignals from "./signals/AthSignals";
import TableToolbar from "../components/ui/TableToolbar";
import ListFilter from "../components/filter/ListFilter";
import Tabs from "../components/ui/Tabs";
import Low52Signals from "./signals/Low52Signals";
export default {
  name: "SignalsView",
  components: {AthSignals, LowHigh52Signals, Low52Signals, TableToolbar, ListFilter, Tabs},
  data() {
    return {
      activeTab: 'ath',
      showFilter: false,
      filters: {},
      defaultSort: 'tradingData.marketCap',
      defaultSortDirection: -1,
      tableKey: 0,
      isLoading: true,
      loadingInterval: null
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    applyFilter(filters) {
      this.filters = filters;
      this.showFilter = false;
      this.$refs['52weeks']?.applyFilter(filters);
      this.$refs['ath']?.applyFilter(filters);
    }
  }
}
</script>

<style scoped lang="scss">

.tabs {
  margin: -5px 0 -5px !important;
  padding: 10px 10px 10px 10px !important;
  gap: 15px;
  background: var(--highlightColorOpacity) !important;

  &[theme="lightMode"] {
    .tab.active {
      color: var(--bgColor);
    }
  }
}

.note {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--textColor);
  margin-top: -5px;
  padding: 0 15px;
}
</style>
